import { Component } from "@angular/core";

@Component({
  selector: 'gen-pathologist',
  template: '<section class="page-content pathologist-route-host"></section>'
})
export class PathologistComponent {
}
